import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M12.8621337,8.39942789 L9.17588687,4.75499952 L9.87894893,4.04387055 L13.8529101,7.97274971 C14.0904606,8.20760536 14.0904614,8.59124804 13.8529105,8.82610416 L9.87894893,12.7549992 L9.17588639,12.0438709 L12.8621337,8.39942789 Z M3.16568542,8.39944267 L6.85802197,4.70710683 L6.15091538,4 L2.17573619,7.97517872 C1.94142222,8.20949221 1.94142032,8.58939123 2.17573619,8.82370663 L6.15091538,12.7988873 L6.85802197,12.0917797 L3.16568542,8.39944267 Z"
        fill-opacity=".9"
        fill-rule="evenodd"
      />
    </svg>
  )
}
const FontCodeIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default FontCodeIcon
